import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { imageSizeTranslation } from '../../../utils/image';
import { prefix, translate } from '../../../utils/locale';
import s from './EditorialLink.scss';

const EditorialLink = ({ index, location, content, setup }) => {
	if (location.type !== 'EDITORIAL') return null;
	const metaInformation = content?.link?.posts?.[0]?.meta?.default || {};
	const indexMetaInformation = index.filter((project) => project.fullUri === metaInformation.fullUri)[0];
	if (!indexMetaInformation) return null;

	return (
		<div className={s.editorialLink}>
			<h3 className={s.editorialLink_title}>{ translate(setup, 'partOfTheProject') }</h3>
			<Link className={s.editorialLink_link} to={prefix(setup, indexMetaInformation.fullUri)}>
				<span className={s.editorialLink_link_dates}>{ translate(setup, indexMetaInformation.acfProjectMeta.content.dates) }</span>
				<figure className={s.editorialLink_link_figure}>
					<LazyImage {...imageSizeTranslation('4', indexMetaInformation.image)} className={['js-lazyLoad', s.editorialLink_link_figure_image, (indexMetaInformation.image.height > indexMetaInformation.image.width ? s.editorialLink_link_figure_image__portrait : null)]} />
					<figcaption className={s.editorialLink_link_figure_caption}>
						<span className={s.editorialLink_link_figure_caption_order}>{ `#${indexMetaInformation.order}` }</span>
						<span className={s.editorialLink_link_figure_caption_title}>{ translate(setup, indexMetaInformation.title) }</span>
					</figcaption>
				</figure>
			</Link>
		</div>
	);
};

const mapState = ({ location, environment }, props) => ({
	index: environment.index,
	location,
	...props,
});

export default hot(module)(connect(mapState)(EditorialLink));
